import { ZomentumEntities } from "../../";

export class NotificationActivity {
	actor = "";

	cta: string[] = new Array<string>();
	entity_id = "";
	entity_type: ZomentumEntities | null = null;
	foreign_id = "";
	icon = "";
	id = "";
	iso_time: Date = new Date();
	message = "";
	new_tab = false;
	object = "";
	origin = "";
	redirect_url = "";
	error_message = "";
	target = "";
	title = "";
	verb: string | NotificationVerb = "";
	notificationId = "";
	isRead = false;
	isSeen = false;
}

export enum NotificationVerb {
	KASEYA = "kaseya_initial_sync_finish",
	HALOPSA = "haloPSA_initial_sync_finish",
	SYNCRO = "syncro_initial_sync_finish",
	REPAIRSHOPR = "repairshopr_initial_sync_finish",
	CONNECTWISE = "connectwise_initial_sync_finish",
	AUTOTASK = "autotask_initial_sync_finish",
	QUICKBOOKS = "quickbooks_initial_sync_finish",
	HUBSPOT = "hubspot_initial_sync_finish",
	INFUSIONSOFT = "infusionsoft_initial_sync_finish"
}

export const NotificationVerbToReduxKeyMapping = {
	[NotificationVerb.KASEYA]: "kaseya",
	[NotificationVerb.HALOPSA]: "halo",
	[NotificationVerb.SYNCRO]: "syncro",
	[NotificationVerb.REPAIRSHOPR]: "repair_shopr",
	[NotificationVerb.CONNECTWISE]: "connectwise",
	[NotificationVerb.AUTOTASK]: "autotask",
	[NotificationVerb.QUICKBOOKS]: "quickbooks",
	[NotificationVerb.HUBSPOT]: "hubspot",
	[NotificationVerb.INFUSIONSOFT]: "infusion_soft"
};

export enum BannerType {
	ADD_PAYMENT_METHOD = "add_payment_method"
}

export enum BannerSeverity {
	INFO = "info",
	WARNING = "warning",
	ERROR = "error"
}

export enum BannerNotificationMessageType {
	TEXT = "plain_text",
	FETCH_CHARGEBEE = "fetch_chargebee_hosted_page"
}

export interface BannerTextPhase {
	text: string;
	message_type: BannerNotificationMessageType;
	value?: string;
}

export interface BannerFeedMessage {
	message: BannerTextPhase[];
	banner_type: BannerType;
	banner_severity: BannerSeverity;
	banner_id: string;
	is_dismissable: boolean;
}

export interface DismissBannnerFeedMessageRequest {
	messages: BannerTextPhase[];
	banner_type: BannerType;
	banner_severity: BannerSeverity;
	banner_id: string;
}

export interface BannerFeedActivity {
	actor: string;
	details: string;
	foreign_id: string;
	id: string;
	object: string;
	origin?: string;
	target: string;
	time: string;
	verb: string;
}

export interface BannerFeedActivityResponse {
	duration: string;
	next: string;
	results: BannerFeedActivity[];
}

export interface BannerFeedActivitySubscribeResponse {
	deleted: string[];
	feed: string;
	new: BannerFeedActivity[];
}

export class NotificationResponse {
	activities: NotificationActivity[] = new Array<NotificationActivity>();
	activity_count = 0;
	actor_count = 0;
	created_at: Date = new Date();
	group = "";
	id = "";
	is_read = false;
	is_seen = false;
	updated_at: Date = new Date();
	verb = "";
	isRead = false;
}
export enum NotificationFeedActivity {
	PURCHASE_ORDER = "purchase_order"
}

export enum NotificationModalType {
	PendingOpportunities = "pending-opportunities",
	ChangeSuggestions = "change-suggestions",
	PendingUsers = "user-requests"
}
